import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'rea-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {

  @Input() bannerText: string;
  @Input() type: string;
  constructor() { }

  ngOnInit(): void {
  }

}
